import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/toastSuccess.svg',
})
export class ToastSuccessComponent {}
